import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./Home";
import Resume from "./pages/Resume";
import Projects from "./pages/Projects";

// FIXED IMPORT PATHS
import AIEducation from "./pages/projects/ai-education";
import MorexAI from "./pages/projects/ai-manufacturing-morex";
import I3FY from "./pages/projects/i3fy";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/resume" element={<Resume />} />
        <Route path="/projects" element={<Projects />} />

        {/* FIXED ROUTES */}
        <Route path="/projects/ai-education" element={<AIEducation />} />
        <Route
          path="/projects/ai-manufacturing-morex"
          element={<MorexAI />}
        />
        <Route path="/projects/i3fy" element={<I3FY />} />
      </Routes>
    </Router>
  );
}

export default App;
